"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var time_1 = require("../../../common/helpers/time");
var drive_types_1 = require("../../../common/types/drive.types");
var sortBy_1 = __importDefault(require("lodash/sortBy"));
var StudentAgendaController = /** @class */ (function () {
    function StudentAgendaController(UserService, $state, $stateParams, CalendarModel) {
        var _this = this;
        this.$state = $state;
        this.date = $stateParams.date;
        this.agendaData = {
            student_id: UserService.getCurrentUser().id,
            date: $stateParams.date,
        };
        CalendarModel.getStudentAgenda(this.agendaData).then(function (response) {
            _this.drives = response.drives.filter(function (drive) {
                drive.date = drive.drive_date;
                drive.type =
                    typeof drive.type === "string" ? drive.type : drive.type.name;
                Object.assign(drive, (0, drive_types_1.formatDriveForDisplay)(drive));
                drive.timestamp = (0, time_1.getUnixTimestamp)((0, time_1.parseDate)(drive.drive_date + " " + drive.start_time));
                return drive.status === "Available" && drive.type === "Drive";
            });
            _this.courses = response.courses.filter(function (course) {
                course.type = "Course";
                course.timestamp = (0, time_1.getUnixTimestamp)((0, time_1.parseDate)((0, time_1.toYMD)((0, time_1.parseDate)(course.date)) + " " + course.time));
                return course;
            });
            _this.items = _this.drives.concat(_this.courses);
            _this.items = (0, sortBy_1.default)(_this.items, function (item) {
                return item.timestamp;
            });
        });
    }
    StudentAgendaController.prototype.next = function () {
        this.$state.go("drivecoach.student.drives.agenda", {
            date: (0, time_1.toYMD)((0, time_1.addDays)((0, time_1.parseDate)(this.date), 1)),
        });
    };
    StudentAgendaController.prototype.prev = function () {
        this.$state.go("drivecoach.student.drives.agenda", {
            date: (0, time_1.toYMD)((0, time_1.subtractDays)((0, time_1.parseDate)(this.date), 1)),
        });
    };
    return StudentAgendaController;
}());
StudentAgendaController.$inject = [
    "UserService",
    "$state",
    "$stateParams",
    "CalendarModel",
];
exports.default = StudentAgendaController;
